export * from './dees-badge.js';
